function setMessageTextAreaSize() {
    var formFieldsLeft = $('.contact-form .form-fields-left'),
        textAreaRight = $('.contact-message');

    textAreaRight.css('height', formFieldsLeft.outerHeight());
}

setMessageTextAreaSize();
$(window).on('resize', function () { setMessageTextAreaSize(); });

$('.contact-form-object').validate({
    rules: {
        full_name: "required",
        email_address: {
            required: true,
            email: true
        },
        // phone_number: "required",
        message: "required"
    },
    submitHandler: function(form) {
        grecaptcha.execute();
    }
});
